import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export const processContent = (body) => {

    // make body as dom element
    let dom = document.createElement('div');
    dom.innerHTML = body;

    let poster = findAttributeOnSiteInfo('icon')[0]

    // find video element
    let videoElementATag = dom.querySelectorAll('a[data-video]');
    videoElementATag.forEach(element => {
        element.innerHTML = `<video class="col-lg-12" poster="${poster}" controls><source src="${element.href}" type="video/mp4"></video>`
    });


    let videoElementVideoTag = dom.querySelectorAll('video');
    videoElementVideoTag.forEach(element => {
        element.poster = poster
    });

    return dom.innerHTML;
}

export const contentSlicer = (content, slicerLength = 75) => {
    if (content == null) return ''
    return content.slice(0, slicerLength) + (content.length > slicerLength ? "..." : "")
}

export const advanceDescriptionCompiler = (description) => {
    try {
        description = JSON.parse(description)
        let result = ''


        for (const [key, item] of Object.entries(description)) {
            result += `${key}:${item}\n`
        }

        return result
    } catch (e) {
        return description
    }
}